<template>
  <div class="response_table">
    <div class="header">
      <label>
        {{ `${translate('client_order.ordering_devices.all_devices')}: ${client_order_info.devices.length}` }} /
        {{ `${translate('client_order.ordering_devices.successes')}: ${client_order_info.success_check_device_count}` }}
      </label>

      <div class="device_filter">
        <div class="filter-item" :class="{ active: device_show === 'all' }" @click="device_show = 'all'">
          {{ translate("client_order.ordering_devices.all_devices") }}
        </div>
        <div class="filter-item" :class="{ active: device_show === 'successes' }" @click="device_show = 'successes'">
          {{ translate("client_order.ordering_devices.successes") }}
        </div>
      </div>

      <div class="buttons">
        <router-link
            :to="'/device_list?&universal_search=client_order_id:' + client_order_info.id"
        >
          <span class="btn btn-primary btn-fill btn-wd">
            {{ translate("client_order.ordering_devices.device_list") }}
          </span>
        </router-link>
        <span
            v-if="info_devices.length > 0"
            class="mdi mdi-content-copy btn btn-fill btn-wd"
            :class="selected_devices.length > 0 ? 'btn-success' : 'btn-primary'"
            @click.prevent="copy_fid()"
        >
          {{ `Copy FID${selected_devices.length ? ` (${selected_devices.length})` : ''}` }}
        </span>
      </div>
    </div>

    <table>
      <thead style="height: 50px; flex:0; display: inline-block">
        <tr>
          <th class="w30" scope="col">
            №
          </th>
          <th class="w30" scope="col">

          </th>
          <th class="status" scope="col">
            {{ translate('client_order.status') }}
          </th>
          <th
              v-if="show_tariffication_and_activation"
              class="tariffication hide_for_print"
              scope="col"
          >
            {{ translate('client_order.tariffication') }}
          </th>
          <th
              v-if="show_tariffication_and_activation"
              class="hide_for_print"
              scope="col"
          >
            {{ translate('client_order.activation') }}
          </th>
          <th class="pointer" @click="change_filter('name')" :class="{ selected: filter_type === 'name' }"
            scope="col">
            {{ translate('client_order.device_name') }}
            <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }" />
          </th>
          <th scope="col">
            {{ translate('client_order.device_model') }}
          </th>
          <th scope="col" colspan="2">
            {{ translate('client_order.rmodems') }}
          </th>

          <th scope="col">
            Snapshot
          </th>

          <th scope="col">
            FactoryTest
          </th>
          <th class="hide_for_print">
            {{ translate('client_order.status') }}
          </th>
          <th class="tariffication w70 hide_for_print" scope="col">
            {{ translate('client_order.section.info') }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(device, key) in info_devices" :key="key" class="device_item">
          <td :data-label="translate('client_order.id')" class="w30">
            {{ key + 1 }}
          </td>
          <td class="w30">
            <input
                type="checkbox"
                :checked="device.checked"
                @change="setDeviceChecked(device, $event.target.checked)"
            >
          </td>
          <td class="status" :data-label="translate('client_order.device_model')">
            <span v-if="Number(device.online_status) !== 1" class="mdi mdi-access-point-off" />
            <span v-else class="mdi mdi-access-point online" />
          </td>
          <td
              v-if="show_tariffication_and_activation"
              class="tariffication hide_for_print"
              :class="check_tariffication(device.tariffication?.status)"
              :data-label="translate('client_order.snapshot_created')"
          >
            <router-link :to="'/tariffication/tariffed_devices?&fid=' + device.fid + '&status=1'">
              {{ device.tariffication?.text }}
            </router-link>
          </td>
          <td
              v-if="show_tariffication_and_activation"
              :data-label="translate('client_order.activation')"
              class="hide_for_print"
          >
            {{ device.activation }}
          </td>
          <td :data-label="translate('client_order.device_name')" class="device_name">
            <router-link :to="{path: '/device/' + device.fid}">
              {{ device.fid }}
            </router-link>
            <p>{{ device.name }}</p>
          </td>

          <td
              :data-label="translate('client_order.device_model')"
              :class="device.model?.sku !== client_order_info.device_sku ? 'bad_sku' : ''"
              :title="device.model?.sku !== client_order_info.device_sku ? translate('client_order.device_model_mismatch') : null"
          >
            <p v-if="device.model?.sku">{{ device.model.sku }}</p>
            <p v-if="device.model?.model_name">{{ device.model.model_name }}</p>
          </td>
          <td :data-label="translate('client_order.rmodems')" colspan="2">
            <div class="rmodems">
              <p>{{ Object.keys(device.rmodems_info).length }}</p>
              <div>
                <p v-for="(rmodem, module) in device.rmodems_info" >
                  {{ `${module}: ${rmodem}`}}
                </p>
              </div>
            </div>
          </td>
          <td data-label="Snapshot" class="hide_for_print" :class="device.task_data?.task_status === 'Success' ? 'success' : ''">
            <template v-if="device.task_data">
              <router-link
                  :to="'/device/' + device.fid + '/testing?snapshot_id=' + device.snapshot_id"
              >
                {{ device.snapshot_id }}
              </router-link>
              <p>{{ device.task_data.task_status }}</p>
              <p>{{ device.task_data.task_user_name }}</p>
              <p>{{ get_date(device.task_data.task_ts) }}</p>
            </template>
          </td>
          <td data-label="FactoryTest" class="hide_for_print" :class="device.factory_test_data?.factory_test_status === 'Success' ? 'success' : ''">
            <template v-if="device.factory_test_data">
              <router-link
                  :to="'/device/' + device.fid + '/testing?factorytest_id=' + device.factory_test_data.factory_test_id"
              >
                {{ device.factory_test_data.factory_test_id }}
              </router-link>
              <p>{{ device.factory_test_data.factory_test_status }}</p>
              <p>{{ device.factory_test_data.factory_test_user_name }}</p>
              <p>{{ get_date(device.factory_test_data.factory_test_ts) }}</p>
            </template>
          </td>
          <td
              :data-label="translate('client_order.status')"
              class="hide_for_print"
              :class="{ success: device.device_order_status === 2, error: device.device_order_status === 3 }"
          >
            <p>{{ device.device_order_status_name }}</p>
            <p>{{ device.user_name }}</p>
            <p>{{ get_date(device.ts) }}</p>
          </td>
          <td :data-label="translate('client_order.section.info')" class="w70 hide_for_print">
            <router-link :to="'/device/' + device.fid + '/testing?snapshot_id=' + device.snapshot_id">
              <span class="mdi mdi-information pointer" />
            </router-link>
            <span class="mdi mdi-cog pointer" @click="show_modal(device)" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import ShowDevice from "../Modal/ShowDevice.vue";

export default {
  name: 'ClientOrderInfoDevices',
  props: {
    client_order_info:{
      type: [Object],
      required: true
    }
  },

  data() {
    return {
      filter_asc: "asc",
      filter_type: "",
      device_show: "all",
      local_devices: [],
    }
  },

  computed: {
    show_tariffication_and_activation(){
      if (this.client_order_info.type === 1) return false
      else if (this.client_order_info.status < 60) return false
      return true
    },
    info_devices() {
      let info_devices = [...this.local_devices];

      if (this.device_show === 'successes') {
        info_devices = info_devices.filter(item => item.device_order_status === 2);
      }

      return info_devices.sort(this.compareNumbers);
    },

    selected_devices() {
      return this.local_devices
          .filter(device => device.checked)
          .map(device => device.fid);
    },
  },

  watch: {
    'client_order_info.devices': {
      handler(devices) {
        this.local_devices = devices.map(device => ({
          ...device,
          checked: false,
        }));
      },
      immediate: true,
      deep: true,
    },
  },


  methods: {
    setDeviceChecked(device, value) {
      const index = this.local_devices.findIndex(item => item.fid === device.fid);

      if (index !== -1) {
        this.$set(this.local_devices[index], 'checked', value);
      }
    },
    check_tariffication(status){
      if (this.client_order_info.type === 1) return ""

      if(status === 0){
        return "tariffication_off"
      } else if (status === 1){
        return "tariffication_on"
      }
      return "no_tariffication"
    },
    copy_fid(){
      let string = ""
      let devices = [...this.info_devices]
      if (this.selected_devices.length > 0) {
        devices = this.local_devices.filter(device => device.checked)
      }
      devices.sort((a, b) => a.fid > b.fid ? 1 : -1).forEach(device => {
        string += `${device.fid}\n`
      })
      this.copy_to_clipboard(string)
      this.global_notify("info", this.translate("clipboard.value_save_buffer"));
    },
    show_modal(device) {
      let t = this.$createElement(ShowDevice, {
        props: {
          device,
          client_order_id: this.client_order_info.id
        },
        on: {
          update: (resp) => {
            this.$emit('update', resp)
            this.$modal.hide("show_device");
          },
          close: () => {
            this.$modal.hide("show_device");
          },
        },
      });
      let temp = {
        render() {
          return t;
        },
      };
      this.$modal.show(
        temp,
        {},
        {
          height: "auto",
          adaptive: true,
          clickToClose: true,
          scrollable: true,
          name: "show_device",
        }
      );
    },

  }
}

</script>

<style lang='scss' scoped>
.response_table {
  height: auto;
  padding: 0;
  margin-bottom: 20px;
  margin-top: 10px;

  .header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 5px;

    .device_filter{
      display: flex;
      border: 1px solid #eaeaea;
      border-radius: 4px;
      .filter-item{
        cursor: pointer;
        padding: 4px 10px;
        cursor: pointer;
        user-select: none;
        transition: background 0.2s;

        &:first-child{
          border-radius: 4px 0 0 4px;
        }

        &:last-child{
          border-radius: 0 4px 4px 0;
        }

        &:hover {
          background: #41b88330;
        }

        &.active {
          background: #41b88330;
          color: #252422;
        }
      }
      .active{
        font-weight: 600;
      }
    }

    .buttons{
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 5px;

      .btn{
        font-size: 10px;
        padding: 0;
      }
    }
  }



  .status {
    width: 8%;
  }

  .tariffication {
    width: 20%;
  }

  .tariffication_on {
    background-color: #41b88370;
  }

  .tariffication_off {
    background-color: #ff000057;
  }

  .no_tariffication {
    background-color: transparent;
  }

  table {
    tbody {
      .online {
        color: #15ab00;
      }

      span.badge {
        font-size: 12px;
      }

      span {
        font-size: 20px;
      }
    }

    td {
      padding: 5px;
      p{
        margin: 0;
        font-size: 10px;
      }
      &.bad_sku,
      &.error{
        background-color: #ff000057;
      }

      &.ready,
      &.success{
        background-color: #41b88330;
      }
    }
  }
  .w70{
    width: 70px;
  }
  .w30{
    width: 30px;
  }
}

</style>
